<template>
    <div class="loading" v-if="loading">
        <div class="wrap">
            <i class="fas fa-sync fa-spin"></i>
        </div>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                loading: true,
            }
        },

        mounted() {
            this.$root.$on('filterProductsStart', () => this.loading = true);
            this.$root.$on('filterProductsDone', () => this.loading = false);
        }
    }
</script>

<style lang="css">
    .loading {
        position:fixed;
        z-index:10
    }
    .loading,.loading .wrap{
        left:0;
        top:0;
        bottom:0;
        right:0
    }
    .loading .wrap{
        background:hsla(0,0%,100%,.8);
        font-size:60px;
        color: #000000;
        display:-webkit-box;
        display:-ms-flexbox;display:flex;
        -webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;
        -ms-flex-align:center;align-items:center;position:absolute}
</style>
